import { useEffect, useState } from 'react';
import { CHAT_SERVER_URL } from 'config/constants';
import { io } from 'socket.io-client';
import { store } from 'store/store';

const useSocket = () => {

    // Get the current state and token
    const state = store.getState();
    const token = state.auth?.token;
    const user = state.auth?.user;

    // Create the socket connection
    const socketInstance = io(CHAT_SERVER_URL, {
        autoConnect: false,
        extraHeaders: {
            authorization: `Bearer ${token}`,
            user: JSON.stringify(user)
        },
    });

    return socketInstance;
};

export default useSocket;